const executeObjectAction = (story, gameData, { target, modifier }) => {
  const asset = story.assets[target] || {}
  let newGameData = null
  let win = false
  let heroShown = null
  let objectShown = null
  let modal = null
  if (asset.kind === 'hero') {
    if (gameData.hero !== target && (modifier === 'toggle' || modifier === 'add')) {
      heroShown = target
      modal = {asset}
      newGameData = {...gameData, hero: target}
      win = true
    } else if (gameData.hero === target && (modifier === 'toggle' || modifier === 'sub')) {
      newGameData = {...gameData, hero: null}
    }
  } else {
    if (!(gameData.objects || []).includes(target) && (modifier === 'toggle' || modifier === 'add')) {
      objectShown = target
      modal = {asset}
      const objects = [...(gameData.objects || []), target]
      newGameData = {...gameData, objects}
      win = true
    } else if ((gameData.objects || []).includes(target) && (modifier === 'toggle' || modifier === 'sub')) {
      newGameData = {...gameData, objects: gameData.objects.filter(x => x !== target)}
    }
  }
  return {
    gameData: newGameData,
    sound: win ? 'objectWin' : 'objectLose',
    heroShown,
    objectShown,
    modal
  }
}

const executeCounterAction = (story, gameData, { target, modifier, value }) => {
  console.log('executeCounterAction', target, modifier, value)
  if (!isNaN(value) && typeof value === 'number') {
    const counter = story.counters[target] || {}
    const newCounters = [...(gameData.counters || [])]
    let counterToModify = newCounters.find(x => x.id === target)
    if (!counterToModify) {
      console.log('cannot find counter with id: ', target)
      return null
    }
    let counters = null
    let error = false
    
    console.log(counterToModify)
    switch (modifier) {
      case 'set': counters = newCounters.map(x => x.id === target ? { id: x.id, value: Math.max(Math.min(value, counter.max), counter.min) } : x); break
      case 'add': counters = newCounters.map(x => x.id === target ? { id: x.id, value: Math.min(x.value + value, counter.max)} : x); break
      case 'sub': counters = newCounters.map(x => x.id === target ? { id: x.id, value: Math.max(x.value - value, counter.min)} : x); break
      default: {
        error = true
      }
    }
    if (!error) {
      const sound = 'counter' + modifier.slice(0,1).toUpperCase() + modifier.slice(1)
      return {
        gameData: {...gameData, counters},
        sound
      }
    }
  }
  return null
}

export const executeAction = (story, gameData, action) => {
  const { kind, params } = action
  switch (kind) {
    case 'object': return executeObjectAction(story, gameData, params)
    case 'counter': return executeCounterAction(story, gameData, params)
    default: console.log('unknown action ', kind)
  }
  return null
}